import moment from "moment";
import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { SEND_PAYMENT_FORM, sendPaymentFormUrl, headers } from "../../utils/constants";

export const sendPaymentForm_action = (memberID, amount, currency, proformaList, from) => async (dispatch) => {
    try {
        const params = {
            UserID: sessionStorage.getItem('UserIDSS') != null ? sessionStorage.getItem('UserIDSS') : null,
            memberID: memberID,
            currency: currency,
            amount: amount,
            proformaList: proformaList,
            from: from,
        }
        console.log("pendingReceiptDetails_action-Action--------------------------->", params)
        // ''
        const res = await axiosPost(sendPaymentFormUrl, params, headers);
        dispatch({
            type: SEND_PAYMENT_FORM,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};  